import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import MainContent from './MainContent';

const Dashboard = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');

  // Set the active tab based on the current URL path
  useEffect(() => {
    if (location.pathname === '/dashboard/profile') {
      setActiveTab('profile');
    } else if (location.pathname === '/dashboard/category') {
      setActiveTab('create-category');
    } else if (location.pathname === '/dashboard/mehendi-form') {
      setActiveTab('create-mehendi-form');
    } else if (location.pathname === '/dashboard/clients') {
      setActiveTab('all-clients');
    }
      else if (location.pathname === '/dashboard/creategalary') {
        setActiveTab('create-galary');
    } else if (location.pathname === '/dashboard/settings') {
      setActiveTab('settings');
    } else if (location.pathname === '/dashboard/logout') {
      setActiveTab('logout');
    }
  }, [location.pathname]);

  return (
    <div className="w-full  flex flex-row  ">
      <Sidebar onTabChange={setActiveTab} />
      {/* sdssjfhdjhfsjvdhfjvfjv */}
      <MainContent activeTab={activeTab} />
    </div>
  );
}

export default Dashboard;
